import React from "react";
import { useFormikContext } from "formik";
import CaretDown24 from "../../../assets/svg/icons/common/CaretDown24";
import Select from "../../../components/form/select";
import useSalesFormStore, {
  fetchMccLowRisk,
} from "../../../stores/sales-form";
import useUserStore from "../../../stores/user";
import baseStyles from "../../create-app/style.module.scss";
import styles from "./styles.module.scss";

const MCCAndEMSOfficeId = ({ isOpen, onToggle, powerappData, emsOfficeOptions }) => {
  const { values, handleChange, handleBlur, setFieldValue } = useFormikContext();
  const user = useUserStore((state) => state.user);
  const isPCUser = useUserStore((state) => state.isPCUser);
  const mccOptions = useSalesFormStore((state) => state.mccOptions);
  const isKurvUser = useUserStore((state) => state.isKurvUser);
  const nonEditableTemplateOrPricingRestricted =
    values.nonEditableTemplateApplied ||
    user?.organization?.pricing_restricted === 1;

  if (!isOpen) {
    return (
      <div className={baseStyles.section}>
        <div className={baseStyles.sectionHeader}>
          <div
            onClick={onToggle}
            className={`${baseStyles.sectionHeaderLeft} ${isOpen && baseStyles.open}`}
          >
            <CaretDown24 />
            <h6 className={baseStyles.sectionTitle}>MCC & KURV Office information</h6>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={baseStyles.section}>
      <div className={baseStyles.sectionHeader}>
        <div
          onClick={onToggle}
          className={`${baseStyles.sectionHeaderLeft} ${isOpen && baseStyles.open}`}
        >
          <CaretDown24 />

          <h6 className={baseStyles.sectionTitle}>MCC & KURV Office information</h6>
        </div>
      </div>

      {isOpen && (
        <div className={styles.content}>
          <div>
            {isPCUser && (
              <Select
                label="MCC ID"
                name="mcc_id"
                placeholder="Select MCC ID"
                async
                search
                onSearchChange={(searchTerm) => {
                  fetchMccLowRisk(searchTerm);
                }}
                options={mccOptions}
                value={values.mcc_id}
                onChange={(value) => {
                  setFieldValue("mcc_id", value);
                }}
                onBlur={handleBlur}
                disabled={nonEditableTemplateOrPricingRestricted}
              />
            )}
            {(isKurvUser || isPCUser) && emsOfficeOptions?.length > 1 && (
              <Select
                label="KURV Office ID"
                name="ems_office_id"
                placeholder="Select KURV Office ID"
                search
                options={emsOfficeOptions}
                value={values.ems_office_id}
                onChange={(opt) => {
                  setFieldValue("ems_office_id", (opt == "" || opt == undefined) ? null : opt);
                }}
                onBlur={handleBlur}
                disabled={nonEditableTemplateOrPricingRestricted}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MCCAndEMSOfficeId;
